import React from 'react';
import { Link } from 'react-router-dom';
import { EnvelopeIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const ContactOptions = ({ id }) => {
  return (
    <div className='mt-8 text-center'>
      <p className='text-slate-600 mb-4'>¿Necesitas ayuda?</p>
      <div className='flex justify-center space-x-4'>
        <a
          href='mailto:legal@claimup.io'
          className='inline-flex items-center px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors duration-150'
        >
          <EnvelopeIcon className='w-5 h-5 mr-2 text-slate-400' />
          legal@claimup.io
        </a>
        <Link
          to={`/chat-debtor/${id}`}
          className='inline-flex items-center px-4 py-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors duration-150'
        >
          <ChatBubbleLeftRightIcon className='w-5 h-5 mr-2 text-slate-400' />
          Chat de soporte
        </Link>
      </div>
    </div>
  );
};

export default ContactOptions;
